import PropTypes from 'prop-types';
import { BsX } from 'react-icons/bs';

const TONES = {
	primary: 'bg-primary-200 text-primary-500',
	success: 'bg-success-200 text-success-700',
	caution: 'bg-caution-200 text-caution-700',
	warning: 'bg-warning-200 text-warning-700',
	neutral: 'bg-bgBase-400 text-bgBase-800',
};

/**
 * Presentational pill tag. `prefix` renders a bold "Prefix:" before the label. When `onRemove` is
 * provided, a trailing ✕ button is rendered; its click is stopped from bubbling so removing a tag
 * inside a clickable row does not trigger the row. With `hoverRemove`, the ✕ is only shown while
 * the chip is hovered. `title` replaces the native hover text, which defaults to the tag text.
 */
const Tag = ({ label, prefix, tone = 'primary', onRemove, size = 'sm', hoverRemove = false, title }) => {
	const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
	const removeClass = hoverRemove ? 'opacity-0 group-hover/tag:opacity-100' : 'opacity-60 hover:opacity-100';
	const text = prefix ? `${prefix}: ${label}` : label;

	return (
		<span className={`group/tag inline-flex min-w-0 items-center gap-1 rounded-full ${TONES[tone]} ${sizeClass}`}>
			<span className="truncate max-w-[160px]" title={title ?? text}>
				{prefix && <span className="font-bold">{prefix}: </span>}
				{label}
			</span>
			{onRemove && (
				<button
					type="button"
					onClick={(e) => {
						e.stopPropagation();
						onRemove();
					}}
					className={`transition-opacity ${removeClass}`}
					title="Entfernen"
				>
					<BsX className="w-3.5 h-3.5" />
				</button>
			)}
		</span>
	);
};

Tag.propTypes = {
	label: PropTypes.string.isRequired,
	prefix: PropTypes.string,
	tone: PropTypes.oneOf(Object.keys(TONES)),
	onRemove: PropTypes.func,
	size: PropTypes.oneOf(['xs', 'sm']),
	hoverRemove: PropTypes.bool,
	title: PropTypes.string,
};

export default Tag;
